module.exports = __webpack_public_path__ + "static/img/rank_160.6ce3ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_160.png
// module id = rbVl
// module chunks = 1